/**
 * @generated SignedSource<<94d9fe3597075f003a6add66e8f70151>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useShowSiderailSoldPricingGuidance_viewer$data = {
  readonly pdpSiderailSoldPricingGuidanceLinkFF: boolean | null;
  readonly " $fragmentType": "useShowSiderailSoldPricingGuidance_viewer";
};
export type useShowSiderailSoldPricingGuidance_viewer$key = {
  readonly " $data"?: useShowSiderailSoldPricingGuidance_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"useShowSiderailSoldPricingGuidance_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useShowSiderailSoldPricingGuidance_viewer",
  "selections": [
    {
      "alias": "pdpSiderailSoldPricingGuidanceLinkFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "pdpSiderailSoldPricingGuidanceLink"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"pdpSiderailSoldPricingGuidanceLink\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "12480fdc7eb4e71e3c1e05cb80b429a5";

export default node;
